import * as React from 'react';

import ControlledNumericInput from 'ui-library/inputs/ControlledNumericInput';
import {LabelStyle} from 'ui-library/inputs/InputConstants';
import InputWrapper from 'ui-library/inputs/InputWrapper';
import {DEGREE_SIGN, MELTING_TEMP_ABBREVIATION} from 'util/UnicodeSymbols';

interface HomologyRegionMinMeltingTempProps {
  homologyRegionMinMeltingTemp: number | null;
  updateHomologyRegionMinMeltingTemp: (temp: number | null) => void;
  isDisabled: boolean;
}

/**
 * An input for setting the minimum melting temp for the homology region in Gibson assembly.
 *
 * @param props Component props
 * @param {(number | null)} props.homologyRegionMinMeltingTemp The minimum melting temperature, in degrees Celsius, of the homology region.
 * @param {function} props.updateHomologyRegionMinMeltingTemp A function that takes a new melting temperature and uses it to update state.
 * @constructor
 */
export function HomologyRegionMinMeltingTemp(props: HomologyRegionMinMeltingTempProps): JSX.Element {
  return (
    <InputWrapper
      id="homologyRegionMinMeltingTemp"
      label={`Min. ${MELTING_TEMP_ABBREVIATION} of binding region (${DEGREE_SIGN}C)`}
      labelStyle={LabelStyle.LABEL}
      isRequired={true}
    >
      <ControlledNumericInput
        value={props.homologyRegionMinMeltingTemp}
        required={true}
        onChange={(e) => {
          props.updateHomologyRegionMinMeltingTemp(e.target.numericValue);
        }}
        isDisabled={props.isDisabled}
      />
    </InputWrapper>
  );
}
